import React, {useEffect, useState} from "react"
import {connect} from "react-redux"
import {useNavigate, useParams} from "react-router-dom"

import {Loading} from "@components/app"

import {IGame} from "@backend/types"
import {GameCreateForm} from "../../components/forms"
import {gameActions, gameApiCalls} from "../../service"


function GameEdit({gameClear}) {
    const [game, setGame] = useState<IGame>()
    const {gameId} = useParams()

    useEffect(() => {
        gameApiCalls.apiCalls
            .getOne(gameId)
            .then(setGame)
    }, [])


    const navigate = useNavigate()

    function onFinish() {
        gameClear()
        navigate("../")
    }

    if (!game)
        return <Loading/>

    return <GameCreateForm game={game} onFinish={onFinish}/>

}

export default connect(null, {
    gameClear: gameActions.actions.clear
})(GameEdit)